export const deliveryTimeHandlers = {
  preorder_expired:
    'Unfortunately your preorder time is no longer available. The time has been updated to {{newWindow}}',
  asap_window_expired:
    'Unfortunately your ASAP order time is no longer available. The time has been updated to {{newWindow}}',
  window_expired:
    'Unfortunately your preorder time is no longer available and there are no other available times.',
}
